import {Layout} from "../../../src/ts/layouts/Layout";
import Swiper from "swiper";
import {l} from "../../../src/ts/debug/debug";

export class Videolist extends Layout {

    private readonly SELECTOR_VIDEO_ITEM: string = '.video-list__videos-item';
    private readonly SELECTOR_VIDEOLINK: string = '.video-list__videos-item-link';
    private readonly SELECTOR_OVERLAY: string = '.videoLink__overlay';
    public readonly SELECTOR_OVERLAY_CLOSE_BUTTON: string = '.videoLink__overlay__close-btn';
    private readonly SELECTOR_OVERLAY_VIDEOCONTAINER: string = '.videoLink__overlay__video-container';

    private readonly OVERLAY_OPEN_CLASS: string = 'overlay_open';

    private $overlay: JQuery;
    private $overlayCloseBtn: JQuery;
    private $iframe: JQuery;

    private $videos: JQuery;

    private swiper: Swiper;
    private swiperOptions: object = {
        slideClass: 'swiper-slide',
        slideActiveClass: 'active',
        slideDuplicateActiveClass: '--duplicate-active',
        slideVisibleClass: '--visible',
        slideDuplicateClass: '--duplicate',
        slideNextClass: '--next',
        slideDuplicateNextClass: '--duplicate-next',
        slidePrevClass: '--prev',
        slideDuplicatePrevClass: '--duplicate-prev',

        spaceBetween: 16,
        watchOverflow: true,
        simulateTouch: true,
        slidesPerView: 'auto',
        centeredSlides: false,

        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16,

        pagination: {
            el: '.pagination',
            type: 'bullets',
            clickable: true,
            bulletClass: 'bullet',
            bulletActiveClass: 'active',
            modifierClass: '',
            currentClass: 'current'
        },
        loop: false,

        breakpoints: {

            768: {
                slidesOffsetBefore: 24,
                slidesOffsetAfter: 24,
                spaceBetween: 24,
            },

            1224: {
                spaceBetween: 24,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
            }
        }
    };

    constructor($elem: JQuery) {
        super($elem);

        let swiper = this.$layout.find('.swiper-container').get(0);

        this.swiper = new Swiper(swiper, this.swiperOptions);
        this.$videos = this.$layout.find(this.SELECTOR_VIDEO_ITEM);

        console.log('hello?');


        this.$videos.each((index, element) => this.addVideoLinkListeners(index, element));


        //console.log(element);
        //console.log($(element));

        //$(element).find('.lol').on('click', (e) => this.onCloseOverlay(e));
        //let $el: JQuery = $(element);

        //7l(this.SELECTOR_OVERLAY_CLOSE_BUTTON);

        /* let $btn: JQuery = $el.find(this.SELECTOR_OVERLAY_CLOSE_BUTTON);
         let $overlay: JQuery = $el.find(this.SELECTOR_OVERLAY);
         let $videoLink: JQuery = $el.find(this.SELECTOR_VIDEOLINK);

         $btn.on('click', (e) => this.onCloseOverlay(e));
         $overlay.on('click', (e) => this.onCloseOverlay(e));
         $videoLink.on('click', (e) => this.onVideoLinkClick(e));*/

        //let $overlay = $(this).find(this.SELECTOR_OVERLAY);
        // });


        //this.$overlay = this.$layout.find(this.SELECTOR_OVERLAY);
        //this.$overlayCloseBtn = this.$overlay.find(this.SELECTOR_OVERLAY_CLOSE_BUTTON);

        //this.$iframe = this.$overlay.find('iframe');


        //this.$layout.find(this.SELECTOR_VIDEOLINK).on('click', (e) => this.onVideoLinkClick(e));
        //this.$overlayCloseBtn.on('click', (e) => this.onCloseOverlay(e));
        //this.$overlay.on('click', (e) => this.onCloseOverlay(e));
    }

    private addVideoLinkListeners(index, element) {
        let $el: JQuery = $(element);
        let $btn: JQuery = $el.find(this.SELECTOR_OVERLAY_CLOSE_BUTTON);
        let $overlay: JQuery = $el.find(this.SELECTOR_OVERLAY);
        let $videoLink: JQuery = $el.find(this.SELECTOR_VIDEOLINK);

        $btn.on('click', (e) => this.onCloseOverlay(e));
        $overlay.on('click', (e) => this.onCloseOverlay(e));
        $videoLink.on('click', (e) => this.onVideoLinkClick(e));
    }

    private onVideoLinkClick(e: JQuery.ClickEvent) {

        const $target = $(e.target).parents(this.SELECTOR_VIDEO_ITEM);

        $('body').addClass(this.OVERLAY_OPEN_CLASS);

        //l('onclick');

        //l($target);

        const $iframe = $target.find(this.SELECTOR_OVERLAY).find('iframe');
        const videoUrl = $iframe.data('video-url');
        $iframe.attr('src', videoUrl);

        $target.find(this.SELECTOR_OVERLAY).addClass(this.OVERLAY_OPEN_CLASS);

        l($target.find(this.SELECTOR_OVERLAY));
        return false;
    }

    private onCloseOverlay(e: JQuery.ClickEvent) {
        const $target = $(e.target).parents(this.SELECTOR_VIDEO_ITEM);
        $('body').removeClass(this.OVERLAY_OPEN_CLASS);
        $target.find(this.SELECTOR_OVERLAY).removeClass(this.OVERLAY_OPEN_CLASS);

        const $iframe = $target.find(this.SELECTOR_OVERLAY).find('iframe');

        $iframe.attr('src', '');
        $iframe.remove();

        $target.find(this.SELECTOR_OVERLAY).find(this.SELECTOR_OVERLAY_VIDEOCONTAINER + ' .video-embed').append($iframe);

        return false;
    }

}

